export default "__VITE_ASSET__S_nvgFkI__"